/**
 * @description 本地化语言相关的内容
 * @author shuowang13
 * @time 20231016
 */
export default {
  computed: {
    // 用户当前使用的语言
    localLanguage() {
      let local = localStorage.getItem('language') || 'zh'
      if (local === 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
  },
}
